import { Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { format, parseISO } from "date-fns";
import { fr } from "date-fns/locale";

type Props = {
  id: string;
  date: Date | string;
  representative: string;
  login: string;
  logout: string;
  numberOfVehicles: number;
};

function CreateDeliveryDealTable({
  id,
  date,
  representative,
  login,
  logout,
  numberOfVehicles,
}: Props) {
  const formatDate = (dateValue: Date | string) => {
    try {
      const parsedDate = typeof dateValue === "string" ? parseISO(dateValue) : dateValue;
      return format(parsedDate, "dd MMM yyyy à HH:mm", { locale: fr });
    } catch (_error) {
      return "Invalid date";
    }
  };

  return (
    <Table
      aria-label="simple table"
      sx={{
        mb: 4,
        "& tbody tr td": {
          borderBottom: "none",
        },
      }}
    >
      <TableHead>
        <TableRow>
          <TableCell>Numéro de contrat :</TableCell>
          <TableCell>Date :</TableCell>
          <TableCell>Mandataire :</TableCell>
          <TableCell>Pick up :</TableCell>
          <TableCell>Livraison :</TableCell>
          <TableCell>Nombre de véhicules :</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow>
          <TableCell>{id}</TableCell>
          <TableCell>{date ? formatDate(date) : <i>Error</i>}</TableCell>
          <TableCell>{representative ?? "Arval"}</TableCell>
          <TableCell>{login}</TableCell>
          <TableCell>{logout}</TableCell>
          <TableCell>{numberOfVehicles}</TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );
}

export default CreateDeliveryDealTable;
